import { useEffect, useMemo, useState } from "react";
import "./FilterModal.scss";
import { FilterModalProps } from "./types";
import { RegionType } from "sagas/types/regions";
import { Checkbox } from "@pickit/pickit-components";

const FilterModal = ({
  isOpen,
  parentRef,
  modalRef,
  regions,
  initialValue,
  valueRef,
  testId,
  fetching,
}: FilterModalProps) => {
  const [modalCoords, setModalCoords] = useState({ x: 0, y: 0 });
  const [optionsState, setOptions] =
    useState<(RegionType & { selected?: boolean })[]>(regions);
  const shouldSplit = useMemo(() => regions.length >= 5, [regions.length]);

  const reduceState = (map: (RegionType & { selected?: boolean })[]) => {
    return map
      .filter((ob) => ob.selected)
      .map((ob) => ob["id"])
      .join(",");
  };

  const onChangeHandlerAll = (e: any) => {
    e.stopPropagation();
    const all = optionsState.every((ob) => ob.selected);
    let map = optionsState.map((ob) => {
      return { ...ob, selected: !all };
    });
    setOptions(map);
    valueRef.current = reduceState(map);
  };

  const onChangeHandler = (option: RegionType & { selected?: boolean }) => {
    const opt = [...optionsState];
    const index = opt.findIndex((ob) => ob.id === option.id);
    opt[index].selected = !option.selected;
    setOptions(opt);
    valueRef.current = reduceState(opt);
  };

  useEffect(() => {
    if (parentRef.current) {
      const parentRect = parentRef.current.getBoundingClientRect();
      setModalCoords({
        x: parentRect.left,
        y: parentRect.top + parentRect.height,
      });
    }
  }, [isOpen, parentRef, fetching]);

  useEffect(() => {
    setOptions(
      regions.map((ob) => {
        return {
          ...ob,
          selected:
            typeof initialValue === "string"
              ? initialValue.split(",").includes(ob.id)
              : false,
        };
      })
    );
    // eslint-disable-next-line
  }, [initialValue, regions]);

  return isOpen ? (
    <div
      className="filter-modal-container"
      style={{ top: modalCoords.y, left: modalCoords.x }}
      ref={modalRef}
    >
      <div className="options-wrapper">
        <div
          className="option-container"
          onMouseDown={onChangeHandlerAll}
          data-testId={`${testId}-select-all`}
        >
          <Checkbox
            label="Todas"
            value={optionsState.every((ob) => ob.selected)}
          />
        </div>
        {(shouldSplit
          ? optionsState.slice(0, regions.length / 2)
          : optionsState
        ).map((ob, i) => (
          <div
            className="option-container"
            onMouseDown={() => onChangeHandler(ob)}
            data-testId={`${testId}-select-${i}`}
          >
            <Checkbox label={ob.name} value={ob.selected} />
          </div>
        ))}
      </div>
      {shouldSplit && (
        <div className="options-wrapper">
          {optionsState
            .slice(regions.length / 2, regions.length)
            .map((ob, i) => (
              <div
                className="option-container"
                onMouseDown={() => onChangeHandler(ob)}
                data-testId={`${testId}-select-${i + regions.length / 2 - 1}`}
              >
                <Checkbox label={ob.name} value={ob.selected} />
              </div>
            ))}
        </div>
      )}
    </div>
  ) : (
    <></>
  );
};

export default FilterModal;
